import React from 'react';
import { Provider, ErrorBoundary, LEVEL_WARN } from '@rollbar/react';

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_CLIENT_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
      environment: `react-${process.env.REACT_APP_AP_ENVIRONMENT}`,
  },
};

const Rollbar = (props) => {
  const { children } = props || {};
  const rollbarEnabled = process.env.REACT_APP_ROLLBAR_ENABLED;
  if (rollbarEnabled) {
    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary level={LEVEL_WARN}>
          {children}
        </ErrorBoundary>
      </Provider>
    );
  };

  return children;
};

export default Rollbar;
